export const getChartThemeColors = theme => {
  return {
    TEXT_COLOR: theme.color['text-core-default'],
    LINE_COLOR: theme.color['do-not-use-gypsum'],
    LINE_COLOR_DARK: theme.color['do-not-use-eerie'],
    TEXT_INACTIVE: theme.color['do-not-use-battleship'],
    BATTLESHIP_TRANSPARENT: 'rgba(203, 214, 226, 0.6)',
    TOOLTIP_BACKGROUND_COLOR: theme.color['fill-surface-default']
  };
};
const ORANGE = '#fea58e';
const DARK_PURPLE = '#9784c2';
const YELLOW = '#f5c78e';
const GREEN = '#a4d398';
const AQUA = '#51d3d9';
const BLUE = '#81c1fd';
const PURPLE = '#bda9ea';
const RED = '#ea90b1';
const DARK_ORANGE = '#c3705c';
const DARK_AQUA = '#009ca2';
const DARK_YELLOW = '#bb915b';
const DARK_PINK = '#b05c7d';
const DARK_BLUE = '#468cc4';
const DARK_GREEN = '#6b9a5b';
export const ColorSeries = {
  DEFAULT: [ORANGE, AQUA, PURPLE, YELLOW, RED, BLUE, GREEN, DARK_ORANGE, DARK_AQUA, DARK_PURPLE, DARK_YELLOW, DARK_PINK, DARK_BLUE, DARK_GREEN]
};